export default __webpack_public_path__ + "static/media/LogoParis.2da73427.svg";